const initialState = {
  survey: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ALUMNI_SURVEY_TASK/POPULATE_SURVEY':
      return {
        ...state,
        survey: action.survey,
      };
    case 'ALUMNI_SURVEY_TASK/POPULATE_SURVEY_QUESTION_ANSWERS':
      return {
        ...state,
        survey: {
          ...state.survey,
          survey: {
            ...(state.survey?.survey ?? {}),
            questions: action.questions,
            startTime: action.startTime,
            endTime: action.endTime,
          },
        },
      };
    default:
      return state;
  }
};
